import { bookList } from 'src/constants/bookList';

/**
 * Auth0 callback URL for the login route. Must match Auth0Provider's redirect_uri
 * and the application's Allowed Callback URLs in the Auth0 dashboard.
 */
export const getAuthLoginRedirectUri = () => `${window.location.origin}${bookList.auth.login}`;
